import React from "react";
import styled from "@emotion/styled";
import { Article } from "@ecologi/shared";

import { Wrapper } from "../Wrapper";
import { ArticleListItem } from "../ArticleListItem";

type Props = {
  articles: Article[];
};

const Container = styled.section`
  padding: 20px 0 60px;
`;

const List = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  margin: 0 auto;
  max-width: 400px;
  padding: 0;

  @media ${(props) => props.theme.bp.tabletUp} {
    max-width: none;
  }
`;

export const ArticlesList: React.FC<Props> = ({ articles }) => (
  <Container>
    <Wrapper isLarge>
      <List>
        {articles.map((article) => (
          <ArticleListItem article={article} key={article.id} isGrey />
        ))}
      </List>
    </Wrapper>
  </Container>
);
